export const host = 'http://185.36.231.91/~rahpardaz/backend.rahpardaz.net/api/v1/'
// export const host = 'http://7810397114.wdev.ir/api/v1/'